import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {LocalizedNumberFormat} from '@/components/common/LocalizedNumberFormat'
import {useCommonContent} from '@/content/common'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {PricingTableRow} from '../PricingTableRow'

type PricingServiceTableItemProps = {
  title: string
  description?: string
  linkUrl?: string
  price: number
  priceNote?: string
  priceLinkUrl?: string
  isDescriptionHiddenOnMobile?: boolean
}

export const PricingServiceTableItem: FC<React.PropsWithChildren<PricingServiceTableItemProps>> = ({
  title,
  description,
  linkUrl,
  price,
  priceNote,
  priceLinkUrl,
  isDescriptionHiddenOnMobile,
}) => {
  const {t} = useTranslation()
  const {fromTitle} = useCommonContent()

  return (
    <>
      <PricingTableRow
        title={title}
        linkUrl={linkUrl}
        description={description}
        isDescriptionHiddenOnMobile={isDescriptionHiddenOnMobile}
      >
        <div className="price">
          {priceLinkUrl ? (
            <Link href={priceLinkUrl} legacyBehavior>
              <a className="link underline">
                <Text fontWeight={TextFontWeight.bold}>
                  <Text element="span">{`${t(fromTitle)} `}</Text>
                  <LocalizedNumberFormat value={price} type="currency" />
                  {priceNote && (
                    <Text element="span" fontWeight={TextFontWeight.bold}>
                      <span className="price-note">{priceNote}</span>
                    </Text>
                  )}
                </Text>
              </a>
            </Link>
          ) : (
            <>
              <Text fontWeight={TextFontWeight.bold}>
                <LocalizedNumberFormat value={price} type="currency" />
              </Text>
              {priceNote && (
                <Text variant={TextVariant.text14} fontWeight={TextFontWeight.bold}>
                  <span className="price-note">{priceNote}</span>
                </Text>
              )}
            </>
          )}
        </div>
      </PricingTableRow>

      <style jsx>{`
        .price {
          display: flex;
          align-items: center;
          white-space: nowrap;
          margin-left: ${theme.spacing[4]};
        }
        .price-note::before {
          content: '/';
          position: relative;
          margin: 0 2px;
        }
        @media ${MOBILE_SCREENSIZE} {
          .price {
            text-align: right;
          }
        }
      `}</style>
    </>
  )
}
